import MyCalendar from "../components/Calendar/Calendar";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";

const Calendar = () => {
  return (
    <Container>
      <PageHeader pageTitle="Takvim" />
      <MyCalendar />
    </Container>
  );
};

export default Calendar;
